<template>
    <section aria-label="Discover one of Alabama's Road Trips." v-if="trips && trips.length > 0">
            <div class="container-fluid">
                <div class="row row-plx">
                  <div class="col-lg-12 mt-5 mb-3">
                  <h2>{{headerText}}</h2>
                </div>
                  <div class="scrolling-wrapper-flexbox d-flex" id="trip-ideas-scroll">
                      <div class="trip-wrapper" v-for="(trip, index) in trips" :key="index">
                          <div class="card-body pulse">
                            <article :aria-label="trip.title">
                            <router-link :to="trip.page_url ? trip.page_url : '/road-trips/' + trip.slug">
                              <div class="trip-image-wrapper" aria-hidden="true" >
                                <span class="trip-number">Trip No. {{trip.tripId ? trip.tripId : trip.tripNumber}}</span>
                                <img class="image-fluid" :alt="trip.title" :src="getImage(trip)" />
                              </div>
                                <div class="body-tx">
                                  <h3>
                                      {{ trip.title }}
                                  </h3>
                                  <p v-html="trip.teaser" class="block-with-text"></p>
                                </div>
                               </router-link>
                              </article>
                          </div>
                      </div>
                    </div>
                    <div class="col-lg-12 mt-5">
                        <router-link class="button" to="/road-trips">More Road Trips <span class="ani-chevron">></span></router-link>
                    </div>
                </div>
            </div>
    </section>
</template>

<script>
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import axios from 'axios';
import { sampleSize } from '../../../store/helpers/helpers';

@Component({
  async mounted() {
    if (this.showRelated) {
      this.trips = this.relatedTrips.slice(0, 3);
    } else {
      await this.loadRandomTripIdeas();
    }
  },

  methods: {
    getImage(trip) {
      let returnImage = trip.mainImage;
      if (trip.thumbnailImageUrl) {
        returnImage = trip.thumbnailImageUrl;
      } else if (trip.mainImageUrl) {
        returnImage = trip.mainImageUrl;
      }
      return returnImage;
    },
  },
})
class TripIdeas extends Vue {
  @Watch('relatedTrips', { immediate: false, deep: false })
  async changed() {
    this.trips = this.relatedTrips.slice(0, 3);
  }

  @Prop({
    type: String,
    default: 'Road Trips',
  })
  headerText;

  @Prop({
    type: Boolean,
    default: false,
  })
  showRelated;

  @Prop({
    type: Array,
  })
  relatedTrips;

  @Prop({
    type: String,
  })
  experience;

  trips = [];

  async loadRandomTripIdeas() {
    if (this.experience) {
      const response = await axios.get(`${process.env.VUE_APP_API2}search_trips?experience=${this.experience}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      });
      if (response && response.data && response.data.trips) {
        this.trips = sampleSize(response.data.trips, 3);
      }
    } else {
      if (!this.$store.state.trips.all || this.$store.state.trips.all.length === 0) {
        await this.$store.dispatch('trips/getAllTrips');
      }
      this.trips = sampleSize(this.trips, 3);
    }
  }
}

export default TripIdeas;
</script>

<style lang="scss" scoped>
article{
  text-align: left;
}
section {
  background-image: url(/images/misc/road-trips-background.jpg);
  height: 90vh;
  min-height: 800px;
  text-align: center;
}

h2 {
     text-align: center !important;
  }

h3 {
  height: 58px;
  overflow: hidden;
}
.row-plx {
  height: 0vh;
}
.big-row {
  height: 60vh;
}
.image-fluid {
    width:100%;
}
.trip-wrapper {
    margin-top:10px;
    display: inline-block;
     width: 28%;
     margin:20px;
}
.card-body {
    background-color:#fff;
    padding:0px;
}
.card-body a {
  color:#173945;
  display:block;
  height:100%;
  position: relative;
  text-decoration: none;
}
.card-body:hover {
  box-shadow: 1px 1px 18px 3px rgba(255, 255, 255,0.25);
-webkit-box-shadow: 1px 1px 18px 3px rgba(255, 255, 255,0.25);
-moz-box-shadow: 1px 1px 18px 3px rgba(255, 255, 255,0.25);
cursor: pointer;
}
.pulse { transition: all .2s ease-in-out; }
.pulse:hover, .pulse:focus { transform: scale(1.05); }
.trip-image-wrapper {
  position: relative;
  height:243px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}
span.trip-number {
  position: absolute;
  bottom: 0px;
  left:20px;
  background-color: #173945;
  color:#fff;
  padding:5px 10px;
  font-weight:700;
  font-size: .8rem;
}
.btn-card {
  position: absolute;
  top:10px;
  left:-5px;
}
.body-tx {
  padding:20px 30px 20px 20px;
  font-family: 'IdealSans-Book';
  font-size:18px;
  border: 2px solid #4e97b2;
  border-top:none;
  min-height:231px;
  max-height:231px;
  }
.block-with-text {
  overflow: hidden;
  position: relative;
  line-height: 1.4em;
  max-height: 6.9em;
  margin-right: -1em;
  padding-right: 1em;
}
.block-with-text:before {
  content: '';
  position: absolute;
  right: 4px;
  bottom: 0px;
}
.block-with-text:after {
  content: '';
  position: absolute;
  right: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.2em;
  background: white;
}

.btn-primary:hover svg {
  transition:  transform .3s;
  transform: translateX(3px)
}
h2 {
  color:#fff;
}
.trip-wrapper{
  position: relative;
}
.Masthead{
  min-height: 800px;
}
.scrolling-wrapper-flexbox {
  justify-content: center;
}
@media only screen and (max-width: 1024px) {
  .Masthead{
    min-height: 650px;
  }
  .scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;

  }
  .scrolling-wrapper-flexbox .trip-wrapper {
    flex: 0 0 auto;
    width:340px;
    padding-right:15px;
    padding-left:15px;
    margin:0;
  }
  .pulse:hover, .pulse:focus, .pulse:active { transform: scale(1.0); }
  .body-tx {
  padding:20px 30px 20px 20px;
  font-family: 'IdealSans-Book';
  font-size:18px;
  min-height:240px;
  max-height:240px;
  }
.trip-image-wrapper {
  height:150px;
}
h3 {
  font-size: 1.3rem;
}
}
@media only screen and (max-width: 768px) {
  .Masthead{
  min-height: 680px;
}
  .scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  }
  .scrolling-wrapper-flexbox .trip-wrapper {
    flex: 0 0 auto;
    width:510px;
    padding-right:15px;
    padding-left:15px;
    margin:0;
    -webkit-overflow-scrolling: touch;
  }
  .pulse:hover, .pulse:focus, .pulse:active { transform: scale(1.0); }
  .body-tx {
  padding:20px 30px 20px 20px;
  font-family: 'IdealSans-Book';
  font-size:18px;
  min-height:250px;
  max-height:250px;
  }
.trip-image-wrapper {
  height:180px;
}
.scrolling-wrapper-flexbox {
  justify-content: flex-start;
}
}
@media only screen and (max-width: 500px) {
  .Masthead{
  min-height: 680px;
}
  .scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  }
  .scrolling-wrapper-flexbox .trip-wrapper {
    flex: 0 0 auto;
    width:380px;
    padding-right:15px;
    padding-left:15px;
    margin:0;
  }
  .pulse:hover, .pulse:focus, .pulse:active { transform: scale(1.0); }
  .body-tx {
  padding:20px 30px 20px 20px;
  font-family: 'IdealSans-Book';
  font-size:18px;
  min-height:250px;
  max-height:250px;
  }
.trip-image-wrapper {
  height:180px;
}
.scrolling-wrapper-flexbox {
  justify-content: flex-start;
}
}
</style>
